"use client";

import { useContentfulInspectorMode } from "@scott/contentful/live-preview-init";
import type { BlockInspectorProps, InspectorProps } from "../../lib/inspector";
import { TextImage, type TextImageProps } from "./text-image";

export type TextImageInspectorProps = BlockInspectorProps &
  InspectorProps<"image">;

export function TextImagePreview(props: Readonly<TextImageProps>) {
  const containerInspector = useContentfulInspectorMode({
    entryId: props.sys?.id,
  });

  const headlineInspector = useContentfulInspectorMode({
    entryId: props.headline?.sys?.id,
    locale: props.headline?.sys?.locale,
  });

  const textInspector = useContentfulInspectorMode({
    entryId: props.text?.sys?.id,
    locale: props.text?.sys?.locale,
  });

  const imageInspector = useContentfulInspectorMode({
    entryId: props.image?.sys?.id,
  });

  return (
    <TextImage
      {...props}
      inspectorProps={{
        container: containerInspector({ fieldId: "internalName" }) ?? undefined,
        headline: headlineInspector({ fieldId: "headline" }) ?? undefined,
        text: textInspector({ fieldId: "text" }) ?? undefined,
        image: imageInspector({ fieldId: "image" }) ?? undefined,
      }}
    />
  );
}
